import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Session is validated via httpOnly cookie sent with the request.
        api
            .get("/auth/me")
            .then((res) => setUser(res.data))
            .catch(() => setUser(false))
            .finally(() => setLoading(false));
    }, []);

    const value = useMemo(() => {
        const login = async (email, password) => {
            const res = await api.post("/auth/login", { email, password });
            setUser(res.data.user);
            return res.data.user;
        };
        const logout = async () => {
            try {
                await api.post("/auth/logout");
            } finally {
                setUser(false);
            }
        };
        return { user, loading, login, logout };
    }, [user, loading]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
